// SDK widget ของ Primerlo (DealerWidget) ใช้ร่วมกันระหว่างหน้า pay ของลูกค้า (/pay/primerlo)
// และหน้า admin Brokers > Create Payment (widget ยืนยันตัวตนก่อนสร้างใบ)
// origin ของหน้าที่ mount ต้องถูกลงทะเบียนกับ Primerlo และ SDK โหลดจาก REACT_APP_PRIMERLO_WIDGET_ORIGIN (default https://widget.primerlo.com)

export const PRIMERLO_WIDGET_ORIGIN = (process.env.REACT_APP_PRIMERLO_WIDGET_ORIGIN || "https://widget.primerlo.com").replace(/\/+$/, "");
export const PRIMERLO_SDK_URL = `${PRIMERLO_WIDGET_ORIGIN}/widget/v1.js`;

// โหลด SDK ครั้งเดียวต่อหน้า หน้าอื่นไม่ต้องแบก script ตัวนี้
let sdkPromise = null;
export const loadPrimerloSdk = () => {
  if (window.DealerWidget) return Promise.resolve(window.DealerWidget);
  if (sdkPromise) return sdkPromise;
  sdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = PRIMERLO_SDK_URL;
    script.async = true;
    script.onload = () => (window.DealerWidget ? resolve(window.DealerWidget) : reject(new Error("DealerWidget missing")));
    script.onerror = () => {
      sdkPromise = null;
      reject(new Error("load widget sdk failed"));
    };
    document.body.appendChild(script);
  });
  return sdkPromise;
};
